export default __webpack_public_path__ + "static/media/sushil.43cf7351.jpg";